import type {
  IndicatorStatusCode,
  MajorIndicatorStatusCode,
} from 'contracts/tracking-v2/invoice-indicators';

export const getMajorStatusCode = (status: IndicatorStatusCode): MajorIndicatorStatusCode => {
  switch (status) {
    case 'preparingForTransitWithinDeadline':
    case 'preparingForTransitOverDeadline':
    case 'preparingForTransitWithoutDeadline':
      return 'preparingForTransit';
    case 'inTransitWithinDeadline':
    case 'inTransitOverDeadline':
    case 'inTransitWithoutDeadline':
      return 'inTransit';
    case 'preparingForDeliveryWithinDeadline':
    case 'preparingForDeliveryOverDeadline':
    case 'preparingForDeliveryWithoutDeadline':
      return 'preparingForDelivery';
    case 'deliveredWithinDeadline':
    case 'deliveredOverDeadline':
    case 'deliveredWithoutDeadline':
      return 'delivered';
  }
};